import AntSpace from 'antd-core/es/space';
import styled, { css } from 'styled-components';

const Root = styled(AntSpace) `
  ${props => props.$fullWidth &&
    css `
      width: 100%;
    `}

  ${props => {
    switch (props.$grow) {
        case 'first':
            return css `
          .tend-ui-space-item:first-child {
            margin-right: auto;
          }
        `;
        case 'last':
            return css `
          .tend-ui-space-item:last-child {
            margin-left: auto;
          }
        `;
        default:
            return;
    }
}}
`;

export { Root };
//# sourceMappingURL=styled.js.map
